import { createContext } from 'react'

const analyticsContext = createContext()

export default analyticsContext
